<hlm-dialog-header>
  <h3 hlmDialogTitle>Conflit lors de la récupération de l'étape</h3>
</hlm-dialog-header>

<div class="p-md">
  <p>Attention, l'étape que vous souhaitez importer existe déjà dans ce Parcours.</p>
  <br />
  <p>Étape sélectionnée :</p>
  <p class="component-medium-semibold">{{ etape.nom }}</p>
  <br />
  <p>Que souhaitez-vous faire ?</p>
</div>

<hlm-dialog-footer class="p-md flex w-full justify-between">
  <button brnDialogClose hlmBtn variant="secondary" type="button">Annuler</button>
  <button (click)="confirm()" hlmBtn type="button">Importer l'étape</button>
</hlm-dialog-footer>
